import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    number: 1,
    title: 'Electricidad Básica',
    description: 'Conceptos básicos, tipos de cables, corriente, herramientas y fundamentos de la electricidad del hogar.'
  }, {
    number: 2,
    title: 'Enchufes y Tomacorrientes',
    description: 'Cómo cambiar enchufes, conectar cables, revisar tomacorrientes y solucionar fallas comunes.'
  }, {
    number: 3,
    title: 'Llaves de Luz y Lámparas',
    description: 'Instalar llaves de luz, cambiar lámparas, portalámparas, plafones y conexiones de iluminación.'
  }, {
    number: 4,
    title: 'Problemas Eléctricos',
    description: 'Qué hacer si salta la térmica, si no funciona un enchufe o una luz, cómo detectar fallas eléctricas en la casa.'
  }, {
    number: 5,
    title: 'Instalaciones Eléctricas',
    description: 'Instalaciones básicas, agregar enchufes, agregar luces, extender cables y conexiones simples del hogar.'
  }, {
    number: 6,
    title: 'Seguridad y Mantenimiento',
    description: 'Seguridad eléctrica, mantenimiento de la instalación, prevención de problemas y cuidado del sistema eléctrico.'
  }];
  return <section className="py-0 bg-brand-50/50 px-4" data-id="element-259">
      <div className="max-w-6xl mx-auto" data-id="element-260">
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-261">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white shadow-sm border border-brand-100 mb-6 transform rotate-3" data-id="element-262">
            <BookOpen className="w-8 h-8 text-brand-500 transform -rotate-3" data-id="element-263" />
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-3 text-gray-900" data-id="element-264">
            📚 LOS 6 TOMOS
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-265">
            Un sistema completo para aprender desde cero y empezar a resolver
            cosas reales en tu casa.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-266">
          {tomos.map((tomo, index) => <motion.div key={index} className="bg-white rounded-2xl p-8 border border-brand-100 shadow-sm relative overflow-hidden group hover:shadow-lg hover:border-brand-300 transition-all duration-300" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-267">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-400 to-brand-300 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-268" />
              <div className="absolute top-0 left-0 w-1.5 h-full bg-brand-400" data-id="element-269" />

              <div className="text-brand-500 font-heading font-bold text-lg mb-2 flex items-center gap-2" data-id="element-270">
                <span className="bg-brand-50 px-2 py-1 rounded-md text-sm" data-id="element-271">
                  Tomo {tomo.number}
                </span>
              </div>
              <h3 className="text-2xl font-heading font-bold text-gray-900 mb-4" data-id="element-272">
                {tomo.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-273">
                {tomo.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}